import { PriorityMapper, type PriorityOption } from "@/models/priority.model";
import { getPriorityOptions } from "@/spz-api/priorities/priorities";
import type { IPriorityRepository } from "../interfaces/priotity-repository.interface";

export class PriorityRepository implements IPriorityRepository {
  async getPriorityOptions(): Promise<PriorityOption[]> {
    const response = await getPriorityOptions();
    return PriorityMapper.toOptions(response.data);
  }
}
